var map = {
	"./de": 31346,
	"./en-gb": 85862,
	"./es": 4321,
	"./fr": 81721,
	"./it": 96632,
	"./ja": 82700,
	"./pl": 32437,
	"./tr": 83099,
	"./zh-cn": 85021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82706;